module.exports = __webpack_public_path__ + "static/img/icon_ysyx.2a49d24a.png";